import { render, staticRenderFns } from "./WeaponSelect.vue?vue&type=template&id=240100d8&scoped=true&"
import script from "./WeaponSelect.vue?vue&type=script&lang=js&"
export * from "./WeaponSelect.vue?vue&type=script&lang=js&"
import style0 from "./WeaponSelect.vue?vue&type=style&index=0&id=240100d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240100d8",
  null
  
)

export default component.exports